<script lang="ts">
	import type { Snippet } from "svelte";
	import type { HTMLSelectAttributes } from "svelte/elements";

	let {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		value = $bindable(),
		/* eslint-disable prefer-const */
		options,
		...rest
		/* eslint-enable prefer-const */
	}: HTMLSelectAttributes & { options: Snippet } = $props();

	// Custom chevron so the select matches the inputs (appearance-none removes the
	// inconsistent native arrow). Encoded to avoid any quote-escaping issues.
	const chevronSvg =
		`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"` +
		` stroke="#6a6767" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;
	const chevronStyle =
		`background-image:url("data:image/svg+xml,${encodeURIComponent(chevronSvg)}");` +
		`background-repeat:no-repeat;background-position:right 0.9rem center;background-size:18px;`;
</script>

<select
	{...rest}
	bind:value
	style={chevronStyle}
	class={[
		"min-h-[3.125rem] w-full cursor-pointer appearance-none bg-white text-ink-900",
		"border-2 border-ink-200 rounded-full py-3 pl-4 pr-11 transition-colors duration-200",
		"hover:border-ink-300 focus:border-secondary focus:outline-none focus:ring-4 focus:ring-secondary/20",
		"[&:user-invalid]:border-status-fault [&:user-invalid]:focus:ring-status-fault/20",
		rest.class,
	]}
>
	{@render options()}
</select>
